// Creates a UTM query string
export const createUtmString = (utmParams = {}) => {
  const params = new URLSearchParams();
  params.append('utm_source', utmParams.utm_source ?? '');
  params.append('utm_medium', utmParams.utm_medium ?? '');
  params.append('utm_campaign', utmParams.utm_campaign ?? '');
  return params.toString();
};

// Builds a URL with UTM parameters, handling separators automatically
export const buildUrl = (baseUrl, utmParams = {}) => {
  const utmString = createUtmString(utmParams);
  const separator = baseUrl.includes('?') ? '&' : '?';
  return `${baseUrl}${separator}${utmString}`;
};
